import styled from '@emotion/styled';
import { RacemapColors } from '@racemap/utilities/consts/common';
import type { CSSProperties, FC } from 'react';
import { IconArrowDown, IconArrowUp } from '../../BasicComponents/Icons';
import type { Column } from './TableBody';

export interface Sorting {
  key: string;
  order: 'ASC' | 'DESC';
}

interface Props {
  // dump bug. multigrid requested key, but for react it is protected and set it undefined
  key?: string;
  cellKey: string;
  column: Column;
  style: CSSProperties;
  sorting: Sorting | null;
  setSorting: (sorting: Sorting) => void;
}

export const TableHeaderCell: FC<Props> = ({ cellKey, column, style, sorting, setSorting }) => {
  const handleCellClick = () => {
    if (sorting != null && sorting.key === column.key) {
      setSorting({
        key: column.key,
        order: sorting.order === 'ASC' ? 'DESC' : 'ASC',
      });
    } else if (column.key === 'current_progress') {
      setSorting({ key: column.key, order: 'DESC' });
    } else {
      setSorting({ key: column.key, order: 'ASC' });
    }
  };

  return (
    <div
      key={`header-${cellKey}`}
      style={{
        ...style,
        height: Number(style.height) + 1,
        boxSizing: 'border-box',
        backgroundColor: 'white',
        borderBottom: `1px solid ${RacemapColors.LightGray}`,
      }}
      onKeyUp={(e) => e.key === 'Enter' && handleCellClick()}
      onClick={handleCellClick}
    >
      {column.headerRender != null ? (
        column.headerRender(column, sorting)
      ) : (
        <TableHeaderCellBody column={column} sorting={sorting} />
      )}
    </div>
  );
};

export const TableHeaderCellBody: FC<{
  column: Column;
  sorting: Sorting | null;
  className?: string;
}> = ({ column, sorting, className = '' }) => {
  return (
    <TableHeaderCellBodyContainer className={className}>
      {column.title}
      {sorting?.key === column?.key &&
        (sorting.order === 'DESC' ? (
          <IconArrowDown style={{ opacity: 0.6 }} />
        ) : (
          <IconArrowUp style={{ opacity: 0.6 }} />
        ))}
    </TableHeaderCellBodyContainer>
  );
};

const TableHeaderCellBodyContainer = styled.div`
  height: 100%;
  padding: 5px 10px;
  font-weight: 600;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;

  :hover {
    background-color: ${RacemapColors.CloudBlue};
  }
`;
